"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainerProgressComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const TrainerService_1 = __importStar(require("../../services/TrainerService"));
const TrainingApiService_1 = __importStar(require("../../services/TrainingApiService"));
const trainer_types_1 = require("../../types/trainer.types");
const events_1 = require("../../events");
const AccountLimitService_1 = __importStar(require("@front/services/AccountLimitService"));
//@ts-ignore                
let rwsTemplate = T.html `<div class="training-section p-3">
  <h2>🏋️ ${'trainer.progress.title'.t()}</h2>
  
  
  <div class="training-controls">
    ${(0, fast_element_1.when)(x => !x.limitReached, (0, fast_element_1.html) `
      <button 
        class="start-training-btn primary-button"
        @click="${x => x.startTraining()}"
        ?hidden="${x => x.trainingProgress.stage !== 'idle'}">
        🚀 ${'trainer.progress.start'.t()}
      </button>
    `)}
    ${(0, fast_element_1.when)(x => x.limitReached && x.trainingProgress.stage === 'idle', (0, fast_element_1.html) `
      <rws-tooltip text="${x => x.limitTooltip}" side="top">
        <button disabled class="start-training-btn secondary-button">
          🚀 ${'trainer.progress.start'.t()}
        </button>
      </rws-tooltip>
    `)}
    
    <button 
      class="stop-training-btn secondary-button"
      @click="${x => x.resetTraining()}"
      ?hidden="${x => x.trainingProgress.stage === 'idle' || x.trainingProgress.stage === 'completed'}">
      ⏹️ ${'trainer.progress.stop'.t()}
    </button>
    
    <button 
      class="new-training-btn secondary-button"
      @click="${x => x.resetTraining()}"
      ?hidden="${x => x.trainingProgress.stage !== 'completed'}">
      🔄 ${'trainer.progress.new'.t()}
    </button>
  </div>

  
  <div class="training-progress" ?hidden="${x => x.trainingProgress.stage === 'idle'}">
    <div class="progress-header">
      <h3>${'trainer.progress.title.text'.t()}</h3>
      <span class="stage-indicator ${x => x.trainingProgress.stage}">
        ${x => x.trainingProgress.stage.toUpperCase()}
      </span>
    </div>
    
    <div class="progress-bar-container">
      <div class="progress-bar">
        <div 
          class="progress-fill" 
          :style="${x => `width: ${x.trainingProgress.progress}%`}">
        </div>
      </div>
      <span class="progress-text">${x => Math.round(x.trainingProgress.progress)}%</span>
    </div>
    
    <p class="progress-message" ?hidden="${x => !x.trainingProgress.message}">
      ${x => x.trainingProgress.message}
    </p>
    
    
    <div class="training-metrics" ?hidden="${x => x.trainingProgress.stage !== 'training'}">
      <div class="metric-grid">
        <div class="metric-item">
          <label>${'trainer.progress.metric.epoch'.t()}</label>
          <span>${x => x.trainingProgress.currentEpoch} / ${x => x.trainingProgress.totalEpochs}</span>
        </div>
        <div class="metric-item">
          <label>${'trainer.progress.metric.loss'.t()}</label>
          <span>${x => { var _a; return (_a = x.trainingProgress.loss) === null || _a === void 0 ? void 0 : _a.toFixed(4); }}</span>
        </div>
        <div class="metric-item">
          <label>${'trainer.progress.metric.accuracy'.t()}</label>
          <span>${x => { var _a; return (_a = (x.trainingProgress.accuracy * 100)) === null || _a === void 0 ? void 0 : _a.toFixed(1); }}%</span>
        </div>
        <div class="metric-item">
          <label>${'trainer.progress.metric.time'.t()}</label>
          <span>${x => Math.round((x.trainingProgress.estimatedTimeRemaining || 0) / 1000)}s</span>
        </div>
      </div>
    </div>
  </div>
</div>
`;
require("./styles/layout.scss");
const styles = T.css `:host {
  display: block;
  width: 100%;
}

.training-section h2 {
  margin: 0 0 2rem 0;
  color: #334155;
}
.training-section .training-controls {
  text-align: center;
  margin-bottom: 2rem;
}
.training-section .training-controls .primary-button {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3);
}
.training-section .training-controls .primary-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);
}
.training-section .training-controls .secondary-button {
  background: #6b7280;
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
.training-section .training-controls .secondary-button:hover {
  background: #4b5563;
  transform: translateY(-2px);
}
.training-section .training-progress {
  background: #f8fafc;
  padding: 2rem;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}
.training-section .training-progress .progress-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.training-section .training-progress .progress-header h3 {
  margin: 0;
  color: #334155;
}
.training-section .training-progress .progress-header .stage-indicator {
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: uppercase;
}
.training-section .training-progress .progress-header .stage-indicator.preprocessing {
  background: #fbbf24;
  color: white;
}
.training-section .training-progress .progress-header .stage-indicator.training {
  background: #3b82f6;
  color: white;
}
.training-section .training-progress .progress-header .stage-indicator.completed {
  background: #10b981;
  color: white;
}
.training-section .training-progress .progress-header .stage-indicator.error {
  background: #ef4444;
  color: white;
}
.training-section .training-progress .progress-bar-container {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}
.training-section .training-progress .progress-bar-container .progress-bar {
  flex: 1;
  height: 20px;
  background: #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
}
.training-section .training-progress .progress-bar-container .progress-bar .progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  transition: width 0.3s ease;
  border-radius: 10px;
}
.training-section .training-progress .progress-bar-container .progress-text {
  font-weight: 600;
  color: #334155;
  min-width: 50px;
}
.training-section .training-progress .progress-message {
  color: #64748b;
  margin: 0 0 1rem 0;
  font-style: italic;
}
.training-section .training-progress .training-metrics {
  border-top: 1px solid #e2e8f0;
  padding-top: 1rem;
}
.training-section .training-progress .training-metrics .metric-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}
.training-section .training-progress .training-metrics .metric-grid .metric-item {
  display: flex;
  justify-content: space-between;
  padding: 0.75rem;
  background: white;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
}
.training-section .training-progress .training-metrics .metric-grid .metric-item label {
  font-weight: 600;
  color: #64748b;
}
.training-section .training-progress .training-metrics .metric-grid .metric-item span {
  font-family: "Monaco", "Menlo", monospace;
  color: #334155;
}

.message-container {
  margin-bottom: 1.5rem;
  padding: 1rem 1.5rem;
  border-radius: 8px;
  border-left: 4px solid;
}
.message-container.error {
  background: #fef2f2;
  border-color: #ef4444;
  color: #991b1b;
}
.message-container.error h3 {
  color: #dc2626;
  margin: 0 0 0.5rem 0;
}
.message-container.warning {
  background: #fffbeb;
  border-color: #f59e0b;
  color: #92400e;
}
.message-container.warning h3 {
  color: #d97706;
  margin: 0 0 0.5rem 0;
}
.message-container ul {
  margin: 0;
  padding-left: 1.5rem;
}
.message-container ul li {
  margin-bottom: 0.25rem;
}

@media (max-width: 768px) {
  .training-section .training-progress .training-metrics .metric-grid {
    grid-template-columns: 1fr;
  }
}`;
const shadowOptions = { "mode": "open" };
let TrainerProgressComponent = class TrainerProgressComponent extends client_1.RWSViewComponent {
    constructor(trainerService, trainingApiService, accountLimitService) {
        super();
        this.trainerService = trainerService;
        this.trainingApiService = trainingApiService;
        this.accountLimitService = accountLimitService;
        this.trainingProgress = {
            stage: 'idle',
            progress: 0
        };
        this.trainingConfig = null;
        this.parsedData = [];
        this.limitReached = false;
        this.limitTooltip = '';
        this.trainingId = null;
        this.progressInterval = null;
    }
    async connectedCallback() {
        super.connectedCallback();
        await this.checkLimits();
    }
    async checkLimits() {
        try {
            const limitCheck = await this.accountLimitService.checkResourceLimitWithCount('trainer');
            this.limitReached = !limitCheck.canCreate;
            this.limitTooltip = limitCheck.message || '';
        }
        catch (error) {
            console.error('Error checking trainer limits:', error);
        }
    }
    async startTraining() {
        try {
            // Check custom model limits before starting training
            const limitCheck = await this.accountLimitService.checkResourceLimitWithCount('trainer');
            if (!limitCheck.canCreate) {
                this.accountLimitService.showLimitExceededPopup(limitCheck.message || 'limits.upgrade.message'.t());
                return;
            }
            this.trainingProgress = {
                stage: 'preparing',
                progress: 5,
                message: 'trainer.progress.preparing'.t()
            };
            this.trainingId = await this.trainerService.startTraining(this.trainingConfig, this.parsedData);
            this.trainingProgress = {
                stage: 'training',
                progress: 10,
                message: 'trainer.progress.started'.t(),
                currentEpoch: 1,
                totalEpochs: this.trainingConfig.epochs
            };
            // Simulate training progress
            this.simulateTrainingProgress(this.trainingConfig.epochs);
            this.emit(events_1.trainerEvents.trainingStarted, this.trainingId);
        }
        catch (error) {
            console.error('trainer.progress.error.starting'.t(), error);
            this.trainingProgress = {
                stage: 'error',
                progress: 0,
                message: error.message
            };
            // Handle failed job completion
            if (this.trainingId) {
                this.handleJobError(error.message);
            }
            this.emit(events_1.trainerEvents.trainingError, error);
        }
    }
    stopTraining() {
        if (this.progressInterval) {
            clearInterval(this.progressInterval);
            this.progressInterval = null;
        }
        this.trainingProgress = {
            stage: 'idle',
            progress: 0
        };
        this.emit(events_1.trainerEvents.trainingStopped, null);
    }
    resetTraining() {
        this.stopTraining();
        this.trainingId = null;
    }
    simulateTrainingProgress(totalEpochs) {
        let currentEpoch = 1;
        let currentProgress = 10;
        this.progressInterval = window.setInterval(() => {
            if (currentEpoch <= totalEpochs) {
                currentProgress = 10 + (currentEpoch / totalEpochs) * 80; // 10% to 90%
                this.trainingProgress = {
                    ...this.trainingProgress,
                    progress: currentProgress,
                    currentEpoch,
                    totalEpochs,
                    loss: Math.max(0.1, 1.0 - (currentEpoch / totalEpochs) * 0.8 + Math.random() * 0.1),
                    accuracy: Math.min(0.99, 0.5 + (currentEpoch / totalEpochs) * 0.4 + Math.random() * 0.1),
                    estimatedTimeRemaining: (totalEpochs - currentEpoch) * 2000,
                    message: 'trainer.progress.training.epoch'.t().replace('{current}', currentEpoch.toString()).replace('{total}', totalEpochs.toString())
                };
                currentEpoch++;
            }
            else {
                // Training completed
                if (this.progressInterval) {
                    clearInterval(this.progressInterval);
                    this.progressInterval = null;
                }
                const finalResults = {
                    modelId: this.trainingId || 'unknown',
                    finalLoss: 0.15,
                    finalAccuracy: 0.92,
                    trainingTime: Date.now(),
                    metricsHistory: []
                };
                this.trainingProgress = {
                    stage: 'completed',
                    progress: 100,
                    message: 'trainer.progress.completed'.t(),
                    currentEpoch: totalEpochs,
                    totalEpochs,
                    loss: 0.15,
                    accuracy: 0.92,
                    estimatedTimeRemaining: 0
                };
                // Call jobDone endpoint to create custom model
                this.handleJobCompletion(finalResults);
                this.emit(events_1.trainerEvents.trainingCompleted, {
                    results: finalResults,
                    progress: this.trainingProgress
                });
            }
        }, 2000); // Update every 2 seconds
    }
    emit(eventName, detail) {
        this.dispatchEvent(new CustomEvent(eventName, { detail, bubbles: true }));
    }
    async handleJobCompletion(results) {
        try {
            if (!this.trainingId) {
                console.warn('trainer.progress.warn.noId'.t());
                return;
            }
            const response = await this.trainingApiService.handleJobDone(this.trainingId, this.trainingId, // Using trainingId as modelId for now
            results, 'completed');
            if (response.success && response.customModel) {
                console.log('trainer.progress.model.created'.t(), response.customModel);
                this.trainingProgress = {
                    ...this.trainingProgress,
                    message: 'trainer.progress.model.available'.t().replace('{name}', response.customModel.name)
                };
            }
            else {
                console.error('trainer.progress.error.model'.t(), response.error);
            }
        }
        catch (error) {
            console.error('trainer.progress.error.completion'.t(), error);
            // Don't block the UI, just log the error
        }
    }
    async handleJobError(errorMessage) {
        try {
            if (!this.trainingId) {
                console.warn('trainer.progress.warn.noIdError'.t());
                return;
            }
            const dummyResults = {
                modelId: this.trainingId,
                finalLoss: 0,
                finalAccuracy: 0,
                trainingTime: 0,
                metricsHistory: []
            };
            await this.trainingApiService.handleJobDone(this.trainingId, this.trainingId, dummyResults, 'failed', errorMessage);
            console.log('trainer.progress.job.failed'.t());
        }
        catch (error) {
            console.error('trainer.progress.error.handling'.t(), error);
            // Don't block the UI, just log the error
        }
    }
};
exports.TrainerProgressComponent = TrainerProgressComponent;
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_d = typeof trainer_types_1.TrainingProgress !== "undefined" && trainer_types_1.TrainingProgress) === "function" ? _d : Object)
], TrainerProgressComponent.prototype, "trainingProgress", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_e = typeof trainer_types_1.TrainingConfig !== "undefined" && trainer_types_1.TrainingConfig) === "function" ? _e : Object)
], TrainerProgressComponent.prototype, "trainingConfig", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TrainerProgressComponent.prototype, "parsedData", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], TrainerProgressComponent.prototype, "limitReached", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], TrainerProgressComponent.prototype, "limitTooltip", void 0);
exports.TrainerProgressComponent = TrainerProgressComponent = __decorate([
    (0, client_1.RWSView)('trainer-progress', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(TrainerService_1.default)),
    __param(1, (0, client_1.RWSInject)(TrainingApiService_1.default)),
    __param(2, (0, client_1.RWSInject)(AccountLimitService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof TrainerService_1.TrainerServiceInstance !== "undefined" && TrainerService_1.TrainerServiceInstance) === "function" ? _a : Object, typeof (_b = typeof TrainingApiService_1.TrainingApiServiceInstance !== "undefined" && TrainingApiService_1.TrainingApiServiceInstance) === "function" ? _b : Object, typeof (_c = typeof AccountLimitService_1.AccountLimitServiceInstance !== "undefined" && AccountLimitService_1.AccountLimitServiceInstance) === "function" ? _c : Object])
], TrainerProgressComponent);
TrainerProgressComponent.defineComponent();
